import { cloneDeep } from "lodash";
import {
    ADD_CROSS_SECTIONAL_AREA_SUCCESS,
    GET_CROSS_SECTIONAL_AREAS_ERROR,
    GET_CROSS_SECTIONAL_AREAS_STARTING,
    GET_CROSS_SECTIONAL_AREAS_SUCCESS,
    UPDATE_CROSS_SECTIONAL_AREA_SUCCESS,
} from "../../../constants/actionTypes";

import initialState from "../../../store/initialState";

export default function crossSectionalAreasReducer(state = initialState.crossSectionalAreas, action) {

    const sortByOrder = (newState) => { }  

    switch (action.type) {
        case GET_CROSS_SECTIONAL_AREAS_STARTING: {
            const newState = cloneDeep(state);
            newState.loading = true;
            newState.loaded = false;
            return newState;
        }

        case GET_CROSS_SECTIONAL_AREAS_SUCCESS: {
            const newState = cloneDeep(state);
            const ids = [];
            action.data.crossSectionalAreaData.forEach((crossSectionalArea) => {
                const crossSectionalAreaId = crossSectionalArea.id;
                ids.push(crossSectionalAreaId);
                newState.map[crossSectionalAreaId] = crossSectionalArea;
            });
            newState.ids = ids;
            newState.page = action.data.page;
            newState.pages = action.data.pages;
            newState.limit = action.data.limit;
            newState.total = action.data.total;
            newState.loading = false;
            newState.loaded = true;
            return newState;
        }

        case GET_CROSS_SECTIONAL_AREAS_ERROR: {
            const newState = cloneDeep(state);
            newState.loading = false;
            newState.loaded = true;
            return newState;
        }

        case ADD_CROSS_SECTIONAL_AREA_SUCCESS: {
            const { crossSectionalAreaData } = action.data;
            const newState = cloneDeep(state);
            const crossSectionalAreaId = crossSectionalAreaData.id;

            newState.map[crossSectionalAreaId] = crossSectionalAreaData;
            newState.ids.push(crossSectionalAreaId);

            sortByOrder(newState);

            return newState;
        }

        case UPDATE_CROSS_SECTIONAL_AREA_SUCCESS: {
            const newState = cloneDeep(state);
            const { crossSectionalAreaData } = action.data;
            const crossSectionalAreaId = crossSectionalAreaData.id;
            newState.map[crossSectionalAreaId] = crossSectionalAreaData;

            sortByOrder(newState);
            return newState;
        }

        default: {
            return state;
        }
    }
}